document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-faq-group]').forEach(function (group) {
    group.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        item.classList.toggle('is-open');
      });
    });
  });
});
